import React, { FC } from "react";
import { AppConfig } from "../../config";
import { useTranslation } from "react-i18next";
import stl from "./index.module.scss";
import errorImg from "../../assets/images/Error-person.svg";

const PaymentStatus: FC = () => {
  const { t } = useTranslation(AppConfig.translationFileNames.base);

  return (
    <div style={{ textAlign: "center" }}>
      <img className={stl.img} src={errorImg} alt={""} />
      <h1 className={stl.title}>{t("spamDetected.title")}</h1>
      <p className={stl.subtitle}>{t("spamDetected.subtitle")}</p>
      <p className={stl.subsubtitle}>{t("spamDetected.subsubtitle")}</p>
    </div>
  );
};

export default PaymentStatus;
